// Types
export interface KPIItem {
  id: string
  label: string
  isChecked: boolean
}

export type AIFeedOption = 'top-managers' | 'tasks-insights' | 'auto-learning' | 'custom'

export interface AIFeedOptionItem {
  id: AIFeedOption
  title: string
  description: string
}

export type DataSourceOption = 'demo' | 'connect' | null

// Constants
export const EXTERNAL_LINK = 'https://testdrive.storee.ai'

export const DEFAULT_KPIS: KPIItem[] = [
  { id: 'sales-target', label: 'sales_vs_target', isChecked: false },
  { id: 'basket-size', label: 'basket_size', isChecked: false },
  { id: 'traffic-conversion', label: 'traffic_and_conversion', isChecked: false },
  { id: 'workforce-productivity', label: 'workforce_productivity', isChecked: false },
]

export const AI_FEED_OPTIONS: AIFeedOptionItem[] = [
  {
    id: 'top-managers',
    title: 'Top Managers First',
    description: 'Prioritize updates by hierarchy. Senior roles appear first.',
  },
  {
    id: 'tasks-insights',
    title: 'Tasks & Insights First',
    description: 'Highlight urgent tasks, KPIs, and data signals.',
  },
  { id: 'auto-learning', title: 'Auto-Learning', description: 'AI adapts to your preferences over time.' },
  { id: 'custom', title: 'Custom Setup', description: 'Write your own instruction.' },
]

// Speech recognition language mapping
export const getSpeechLanguage = (langCode: string): string => {
  const map: Record<string, string> = {
    en: 'en-US',
    he: 'he-IL',
    es: 'es-ES',
    it: 'it-IT',
    pt: 'pt-PT',
    ru: 'ru-RU',
    lt: 'lt-LT',
    lv: 'lv-LV',
    tr: 'tr-TR',
    bg: 'bg-BG',
    'pt-BR': 'pt-BR',
  }
  if (map[langCode]) return map[langCode]
  const short = langCode?.split('-')[0]
  if (short && map[short]) return map[short]
  return 'en-US'
}

// Pulse animation for mic button - preserves translateX(-50%) for centering
export const pulseAnimation = `
  @keyframes pulse {
    0% { transform: translateX(-50%) scale(1); box-shadow: 0 0 0 0 rgba(225, 29, 72, 0.7); }
    70% { transform: translateX(-50%) scale(1.05); box-shadow: 0 0 0 10px rgba(225, 29, 72, 0); }
    100% { transform: translateX(-50%) scale(1); box-shadow: 0 0 0 0 rgba(225, 29, 72, 0); }
  }
`
